module.exports = __webpack_public_path__ + "img/delete.dc1f55d5.svg";